import { Link, useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Header />
      <main className="pt-16 min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-7xl md:text-9xl font-display font-black text-primary-200 select-none">
          404
        </h1>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-4">
          页面未找到
        </h2>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
      </main>
      <Footer />
    </>
  );
}